﻿export class Document {
    public DocumentID: Number;
    public CaseID: string;
    public DocumentTypeID: string;
    public DocumentName: string;
    public DocumentPath: string;
    public UploadedByID: string;
    public Juveniles: any;
    public CalendarEvents: any;

    constructor() {
        this.DocumentID = 0;
        this.CaseID = "0";
        this.DocumentTypeID = "-1";
        this.DocumentName = "";
        this.DocumentPath = "";
        this.UploadedByID = "-1";

    }
}